import { createMutation } from 'react-query-kit';

import { privateApi } from 'api';

import { SerializedEditorState } from 'lexical';
import { GetAgreementResult } from '../tenant/GetGeneralStudentAgreement';

export type UpdatePackageTermsParams = {
    packageId: string;
    data: {
        content: SerializedEditorState;
    }
};

export type UpdatePackageTermsResult = GetAgreementResult;

async function updatePackageTerms(params: UpdatePackageTermsParams): Promise<UpdatePackageTermsResult> {
    const { packageId, data } = params;

    // make api call
    const result = await privateApi.patch<UpdatePackageTermsResult>(`${import.meta.env.VITE_API_BASE_URL}/packages/${packageId}/agreement`, data);

    // return the data object
    return result.data;
}

const useUpdatePackageTerms = createMutation({
    mutationFn: async (variables: UpdatePackageTermsParams) => updatePackageTerms(variables),
});

export { updatePackageTerms, useUpdatePackageTerms };
